import { DataStream } from "@/core/exif/data-stream"
import { TagType } from "@/core/exif/tag-types"
import { IFDEntry, writeDirectory } from "@/core/exif/ifd"
import { TagCode } from "@/core/exif/tag-codes"
import { rgbaToRgb } from "@/core/utils/rgba-to-rgb"
import { displayP3 } from "@/core/exif/icc-profiles"
import { PixelData } from "@/core/utils/image-data"

export function encodeDNG({ data, width, height }: PixelData) {
	if (data instanceof Uint8Array || data instanceof Float32Array) {
		throw new Error("DNG cannot be encoded with 8-bit data")
	}

	const textEncoder = new TextEncoder()
	const header = new ArrayBuffer(1024)
	const dataView = new DataView(header)
	const dataStream = new DataStream(dataView)

	const rgbData = rgbaToRgb(data, width, height)

	const entries: IFDEntry[] = [
		{ tag: TagCode.NewSubFileType, type: TagType.LONG, value: 16 }, // Enhanced image
		{ tag: TagCode.ImageWidth, type: TagType.LONG, value: width },
		{ tag: TagCode.ImageLength, type: TagType.LONG, value: height },
		{ tag: TagCode.BitsPerSample, type: TagType.SHORT, value: [16, 16, 16] },
		{ tag: TagCode.Compression, type: TagType.SHORT, value: 1 },
		{ tag: TagCode.PhotometricInterpretation, type: TagType.SHORT, value: 34892 }, // LinearRaw
		// { tag: TagCode.PhotometricInterpretation, type: TagType.SHORT, value: 2 },
		{ tag: TagCode.StripOffsets, type: TagType.LONG, value: header.byteLength },
		{ tag: TagCode.Orientation, type: TagType.BYTE, value: 1 },
		{ tag: TagCode.SamplesPerPixel, type: TagType.SHORT, value: 3 },
		{ tag: TagCode.RowsPerStrip, type: TagType.LONG, value: height },
		{ tag: TagCode.StripByteCounts, type: TagType.LONG, value: width * height * 3 * 2 },
		{ tag: TagCode.XResolution, type: TagType.RATIONAL, value: 72 },
		{ tag: TagCode.YResolution, type: TagType.RATIONAL, value: 72 },
		{ tag: TagCode.ResolutionUnit, type: TagType.SHORT, value: 2 },
		{ tag: TagCode.ICCProfile, type: TagType.UNDEFINED, value: displayP3 },
		{ tag: TagCode.DNGVersion, type: TagType.BYTE, value: [1, 5, 0, 0] },
		{ tag: TagCode.BlackLevel, type: TagType.SHORT, value: 0 },
		{
			tag: TagCode.UniqueCameraModel,
			type: TagType.ASCII,
			value: textEncoder.encode("SONY ILCE-7M3"),
		},
	]

	dataStream.setUint16(!dataStream.littleEndian ? 0x4d4d : 0x4949) // byte order
	dataStream.setUint16(42) // 42
	dataStream.setUint32(8) // 1st IFD offset

	writeDirectory(dataStream, entries)

	return new Blob([header, rgbData as unknown as BlobPart], { type: "image/dng" })
}
